import { useEffect, useState } from "react";
import {
  Box,
  Text,
  Grid,
  GridItem,
  Heading,
  Button,
  useDisclosure,
  useToast,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  FormControl,
  FormLabel,
  Badge,
  Icon,
  Spinner,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  HStack,
  Divider,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  VStack,
  List,
  ListItem,
  ListIcon,
  Collapse,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon
} from "@chakra-ui/react";
import { useRef } from "react";

// Componentes de ícones customizados
const CustomIcon = ({ children }) => (
  <Icon viewBox="0 0 24 24" mr={2}>
    {children}
  </Icon>
);

// Ícone de Servidor
const ServerIcon = (props) => (
  <CustomIcon {...props}>
    <path fill="currentColor" d="M4,1H20A1,1 0 0,1 21,2V6A1,1 0 0,1 20,7H4A1,1 0 0,1 3,6V2A1,1 0 0,1 4,1M4,9H20A1,1 0 0,1 21,10V14A1,1 0 0,1 20,15H4A1,1 0 0,1 3,14V10A1,1 0 0,1 4,9M4,17H20A1,1 0 0,1 21,18V22A1,1 0 0,1 20,23H4A1,1 0 0,1 3,22V18A1,1 0 0,1 4,17M9,5H10V3H9V5M9,13H10V11H9V13M9,21H10V19H9V21M5,3V5H7V3H5M5,11V13H7V11H5M5,19V21H7V19H5Z" />
  </CustomIcon>
);

// Ícone de IP
const IPIcon = (props) => (
  <CustomIcon {...props}>
    <path fill="currentColor" d="M16,4L9,8L2,4V6L9,10L16,6V4M0,4V8L5,10L0,12V16L9,12L16,16V12L11,10L16,8V4L9,8L0,4Z" />
  </CustomIcon>
);

// Ícone de MAC
const MacIcon = (props) => (
  <CustomIcon {...props}>
    <path fill="currentColor" d="M8,2A2,2 0 0,0 6,4V6H10V4A2,2 0 0,0 8,2M16,2A2,2 0 0,0 14,4V6H18V4A2,2 0 0,0 16,2M4,8V10H6V18H10V10H14V18H18V10H20V8H4Z" />
  </CustomIcon>
);

// Ícone de Refresh
const RefreshIcon = (props) => (
  <CustomIcon {...props}>
    <path fill="currentColor" d="M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z" />
  </CustomIcon>
);

// Ícone de Status
const StatusIcon = (props) => (
  <CustomIcon {...props}>
    <path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" />
  </CustomIcon>
);

// Ícone de Câmera
const CameraIcon = (props) => (
  <CustomIcon {...props}>
    <path fill="currentColor" d="M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z" />
  </CustomIcon>
);

// Ícone de Algoritmo
const AlgorithmIcon = (props) => (
  <CustomIcon {...props}>
    <path fill="currentColor" d="M7,5H21V7H7V5M7,13V11H21V13H7M4,4.5A1.5,1.5 0 0,1 5.5,6A1.5,1.5 0 0,1 4,7.5A1.5,1.5 0 0,1 2.5,6A1.5,1.5 0 0,1 4,4.5M4,10.5A1.5,1.5 0 0,1 5.5,12A1.5,1.5 0 0,1 4,13.5A1.5,1.5 0 0,1 2.5,12A1.5,1.5 0 0,1 4,10.5M7,19V17H21V19H7M4,16.5A1.5,1.5 0 0,1 5.5,18A1.5,1.5 0 0,1 4,19.5A1.5,1.5 0 0,1 2.5,18A1.5,1.5 0 0,1 4,16.5Z" />
  </CustomIcon>
);

// Ícone de Tempo
const TimeIcon = (props) => (
  <CustomIcon {...props}>
    <path fill="currentColor" d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z" />
  </CustomIcon>
);

// Ícone de Disco (Storage)
const DiskIcon = (props) => (
  <CustomIcon {...props}>
    <path fill="currentColor" d="M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M12,4A6,6 0 0,0 6,10C6,13.31 8.69,16 12.1,16L11.22,13.77C10.23,13.4 9.5,12.56 9.5,11.5A2.5,2.5 0 0,1 12,9C13.11,9 14.11,9.63 14.5,10.5H16.66C16.12,8.72 14.38,7.41 12.33,7.41C11.83,7.41 11.33,7.5 10.86,7.65L12,4M18,11H13L15,16H20L18,11Z" />
  </CustomIcon>
);

// Ícone de Aviso/Saúde
const HealthIcon = (props) => (
  <CustomIcon {...props}>
    <path fill="currentColor" d="M10.5,13H8V10H10.5V8H13V10H15.5V13H13V15H10.5V13M12,2L4,5V11.09C4,16.14 7.41,20.85 12,22C16.59,20.85 20,16.14 20,11.09V5L12,2Z" />
  </CustomIcon>
);

const Machines = () => {
  const [machines, setMachines] = useState([]);
  const [editMachine, setEditMachine] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [stats, setStats] = useState({ total: 0, active: 0, inactive: 0 });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  
  // Estado para confirmar exclusão
  const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false);
  const [machineToDelete, setMachineToDelete] = useState(null);
  const [deleteStep, setDeleteStep] = useState(1);
  const [deleteLinkedCameras, setDeleteLinkedCameras] = useState([]);
  const [checkingLinkedCameras, setCheckingLinkedCameras] = useState(false);
  const cancelRef = useRef();
  
  // Estado para controlar o carregamento das câmeras por máquina
  const [machinesCameras, setMachinesCameras] = useState({});
  const [loadingCameras, setLoadingCameras] = useState({});
  
  // Estado para armazenamento
  const [storageInfo, setStorageInfo] = useState(null);
  const [loadingStorage, setLoadingStorage] = useState(false);
  const [checkingHealth, setCheckingHealth] = useState(false);

  useEffect(() => {
    fetchMachines();
    fetchStorageInfo();
  }, []);

  const fetchMachines = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/machines', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (!response.ok) {
        throw new Error('Erro ao buscar máquinas');
      }
      const data = await response.json();
      
      // Verifica se last_request_time é maior que 10 minutos e marca como offline
      const now = new Date();
      const tenMinutesAgo = new Date(now.getTime() - 10 * 60 * 1000); // 10 minutos atrás
      
      const processedMachines = data.map(machine => {
        // Se last_request_time for mais antigo que 10 minutos, marca como offline
        if (machine.last_request_time) {
          const lastRequestTime = new Date(machine.last_request_time);
          if (lastRequestTime < tenMinutesAgo) {
            return { ...machine, status: false };
          }
        }
        return machine;
      });
      
      setMachines(processedMachines);
      
      // Calcula estatísticas
      const totalMachines = processedMachines.length;
      const activeMachines = processedMachines.filter(machine => machine.status).length;
      setStats({
        total: totalMachines,
        active: activeMachines,
        inactive: totalMachines - activeMachines
      });
    } catch (error) {
      toast({
        title: "Erro ao buscar máquinas",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchMachineCameras = async (machineId) => {
    if (machinesCameras[machineId]) return; // Se já temos os dados, não busque novamente
    
    setLoadingCameras(prev => ({ ...prev, [machineId]: true }));
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/machines/${machineId}/active_cameras`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (!response.ok) {
        throw new Error('Erro ao buscar câmeras ativas');
      }
      const data = await response.json();
      setMachinesCameras(prev => ({ ...prev, [machineId]: data }));
    } catch (error) {
      toast({
        title: "Erro ao buscar câmeras ativas",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoadingCameras(prev => ({ ...prev, [machineId]: false }));
    }
  };

  const fetchStorageInfo = async (forceRefresh = false) => {
    setLoadingStorage(true);
    try {
      const token = localStorage.getItem('token');
      const url = forceRefresh 
        ? '/api/storage/status?refresh=true' 
        : '/api/storage/status';
      
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (!response.ok) {
        throw new Error('Erro ao buscar informações de armazenamento');
      }
      const result = await response.json();
      
      // A API retorna { success: true, data: {...} }
      const data = result.data || result;
      
      console.log('Storage info recebida:', data);
      setStorageInfo(data);
      
      if (forceRefresh && result.refreshed) {
        toast({
          title: "Estatísticas atualizadas",
          description: "Dados de armazenamento atualizados com sucesso",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Erro ao buscar storage:', error);
      // Não mostra toast de erro para não poluir a tela
      setStorageInfo(null);
    } finally {
      setLoadingStorage(false);
    }
  };

  const handleCheckHealth = async () => {
    setCheckingHealth(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/storage/check-health', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (!response.ok) {
        throw new Error('Erro ao verificar saúde dos discos');
      }
      const data = await response.json();
      
      // Atualiza as informações de storage
      await fetchStorageInfo();
      
      toast({
        title: "Verificação concluída",
        description: data.message || "Status dos discos atualizado",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erro ao verificar saúde dos discos",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setCheckingHealth(false);
    }
  };

  const formatBytes = (bytes) => {
    if (!bytes || bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  };

  const getUsagePercentage = (used, total) => {
    if (!total || total === 0) return 0;
    return Math.round((used / total) * 100);
  };

  const getUsageColor = (percentage) => {
    if (percentage >= 90) return 'red';
    if (percentage >= 75) return 'orange';
    if (percentage >= 50) return 'yellow';
    return 'green';
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditMachine(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleEditMachine = (machine) => {
    setEditMachine(machine);
    onOpen();
  };

  const handleUpdateMachine = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/machines/${editMachine.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(editMachine),
      });

      if (!response.ok) {
        throw new Error('Erro ao atualizar máquina');
      }

      const updatedMachine = await response.json();
      setMachines(prev =>
        prev.map(machine =>
          machine.id === updatedMachine.id ? updatedMachine : machine
        )
      );
      
      toast({
        title: "Máquina atualizada",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
      
      setEditMachine(null);
      onClose();
    } catch (error) {
      toast({
        title: "Erro ao atualizar máquina",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  
  const handleRefreshStatus = async () => {
    setRefreshing(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/machines/refresh-status', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (!response.ok) {
        throw new Error('Erro ao atualizar status das máquinas');
      }
      
      // Atualiza lista de máquinas com os novos status
      await fetchMachines();
      
      // Limpa o cache de câmeras para forçar nova busca
      setMachinesCameras({});
      
      toast({
        title: "Status atualizado",
        description: "Status de todas as máquinas foi atualizado",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erro ao atualizar status",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setRefreshing(false);
    }
  };
  
  // Abre o diálogo de confirmação de exclusão
  const openDeleteConfirmation = async (machine) => {
    setMachineToDelete(machine);
    setDeleteStep(1);
    setDeleteLinkedCameras([]);
    setIsDeleteAlertOpen(true);

    try {
      setCheckingLinkedCameras(true);
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/machines/${machine.id}/linked-cameras`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) throw new Error('Erro ao buscar câmeras vinculadas');

      const data = await response.json();
      setDeleteLinkedCameras(Array.isArray(data.cameras) ? data.cameras : []);
    } catch (error) {
      toast({
        title: "Aviso",
        description: "Não foi possível verificar as câmeras vinculadas antes de excluir.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setCheckingLinkedCameras(false);
    }
  };
  
  // Executa a exclusão após confirmação
  const handleDeleteMachine = async () => {
    if (!machineToDelete) return;

    const hasLinkedCameras = deleteLinkedCameras.length > 0;

    if (deleteStep === 1 && hasLinkedCameras) {
      setDeleteStep(2);
      return;
    }
    
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/machines/${machineToDelete.id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      // Check for error responses
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erro ao excluir máquina');
      }

      const result = await response.json();
      
      // Remove a máquina da lista
      setMachines(prev => prev.filter(machine => machine.id !== machineToDelete.id));
      
      // Remove do cache de câmeras
      const updatedCache = { ...machinesCameras };
      delete updatedCache[machineToDelete.id];
      setMachinesCameras(updatedCache);
      
      // Recalcula estatísticas
      setStats(prev => ({
        total: prev.total - 1,
        active: machineToDelete.status ? prev.active - 1 : prev.active,
        inactive: machineToDelete.status ? prev.inactive : prev.inactive - 1
      }));
      
      toast({
        title: "Máquina excluída",
        description: result.detachedCamerasCount > 0
          ? `A máquina ${machineToDelete.name} foi excluída e ${result.detachedCamerasCount} câmera(s) foram desvinculadas.`
          : `A máquina ${machineToDelete.name} foi excluída com sucesso.`,
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erro ao excluir máquina",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setMachineToDelete(null);
      setDeleteStep(1);
      setDeleteLinkedCameras([]);
      setIsDeleteAlertOpen(false);
    }
  };

  const formatLastRequestTime = (timestamp) => {
    if (!timestamp) return "Nunca";
    
    const lastRequest = new Date(timestamp);
    const now = new Date();
    const diffMs = now - lastRequest;
    
    // Se for menos de um minuto
    if (diffMs < 60000) {
      return "Agora mesmo";
    }
    
    // Se for menos de uma hora
    if (diffMs < 3600000) {
      const minutes = Math.floor(diffMs / 60000);
      return `Há ${minutes} ${minutes === 1 ? 'minuto' : 'minutos'}`;
    }
    
    // Se for menos de um dia
    if (diffMs < 86400000) {
      const hours = Math.floor(diffMs / 3600000);
      return `Há ${hours} ${hours === 1 ? 'hora' : 'horas'}`;
    }
    
    // Para mais de um dia
    return lastRequest.toLocaleDateString('pt-BR') + ' ' + 
           lastRequest.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <Box p={6} flex="1" minH="100vh" bg="gray.100">
      <Flex justify="space-between" align="center" mb={4}>
        <Heading display="flex" alignItems="center">
          <ServerIcon />
          Máquinas de Processamento
        </Heading>
        <Button 
          colorScheme="teal" 
          onClick={handleRefreshStatus} 
          isLoading={refreshing} 
          leftIcon={<RefreshIcon />}
        >
          Atualizar Status
        </Button>
      </Flex>
      
      {/* Painel de estatísticas */}
      <Grid templateColumns="repeat(3, 1fr)" gap={6} mb={6}>
        <GridItem w="100%" bg="white" boxShadow="md" borderRadius="md" p={4}>
          <Stat>
            <StatLabel fontSize="lg">Total de Máquinas</StatLabel>
            <StatNumber fontSize="3xl">{stats.total}</StatNumber>
            <StatHelpText>Máquinas registradas</StatHelpText>
          </Stat>
        </GridItem>
        
        <GridItem w="100%" bg="white" boxShadow="md" borderRadius="md" p={4}>
          <Stat>
            <StatLabel fontSize="lg" color="green.500">Máquinas Ativas</StatLabel>
            <StatNumber fontSize="3xl" color="green.500">{stats.active}</StatNumber>
            <StatHelpText>Online e funcionando</StatHelpText>
          </Stat>
        </GridItem>
        
        <GridItem w="100%" bg="white" boxShadow="md" borderRadius="md" p={4}>
          <Stat>
            <StatLabel fontSize="lg" color="red.500">Máquinas Inativas</StatLabel>
            <StatNumber fontSize="3xl" color="red.500">{stats.inactive}</StatNumber>
            <StatHelpText>Offline ou com problemas</StatHelpText>
          </Stat>
        </GridItem>
      </Grid>

      {/* Painel de Armazenamento */}
      <Box bg="white" boxShadow="md" borderRadius="md" p={6} mb={6}>
        <Flex justify="space-between" align="center" mb={4}>
          <Heading size="md" display="flex" alignItems="center">
            <DiskIcon />
            Armazenamento de Imagens
          </Heading>
          <HStack spacing={2}>
            <Button
              size="sm"
              colorScheme="green"
              onClick={() => fetchStorageInfo(true)}
              isLoading={loadingStorage}
              leftIcon={<Icon viewBox="0 0 24 24">
                <path fill="currentColor" d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
              </Icon>}
            >
              Atualizar Estatísticas
            </Button>
            <Button
              size="sm"
              colorScheme="blue"
              onClick={handleCheckHealth}
              isLoading={checkingHealth}
              leftIcon={<HealthIcon />}
            >
              Verificar Saúde
            </Button>
          </HStack>
        </Flex>

        {loadingStorage ? (
          <Flex justify="center" align="center" height="100px">
            <Spinner size="md" />
          </Flex>
        ) : storageInfo && storageInfo.disks ? (
          <VStack spacing={4} align="stretch">
            {/* Informações gerais */}
            <HStack spacing={8} flexWrap="wrap">
              <Box>
                <Text fontSize="sm" color="gray.600">Disco Ativo</Text>
                <Text fontSize="lg" fontWeight="bold">
                  Disco {(storageInfo.currentDiskIndex || 0) + 1} de {storageInfo.totalDisks || 0}
                </Text>
              </Box>
              <Box>
                <Text fontSize="sm" color="gray.600">Total de Discos</Text>
                <Text fontSize="lg" fontWeight="bold">{storageInfo.totalDisks || 0}</Text>
              </Box>
              <Box>
                <Text fontSize="sm" color="gray.600">Discos Saudáveis</Text>
                <Text fontSize="lg" fontWeight="bold" color="green.500">
                  {storageInfo.healthyDisks || 0}
                </Text>
              </Box>
            </HStack>

            <Divider />

            {/* Lista de discos */}
            <VStack spacing={3} align="stretch">
              {storageInfo.disks.map((disk, index) => {
                const usagePercent = disk.stats ? getUsagePercentage(disk.stats.used, disk.stats.total) : 0;
                const colorScheme = getUsageColor(usagePercent);
                
                return (
                  <Box
                    key={index}
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                    borderColor={disk.isHealthy ? 'gray.200' : 'red.300'}
                    bg={disk.isActive ? 'blue.50' : 'white'}
                  >
                    <Flex justify="space-between" align="center" mb={2}>
                      <HStack>
                        <DiskIcon />
                        <Text fontWeight="bold">
                          Disco {index + 1}
                          {disk.isActive && (
                            <Badge ml={2} colorScheme="blue">Ativo</Badge>
                          )}
                        </Text>
                      </HStack>
                      <Badge colorScheme={disk.isHealthy ? 'green' : 'red'}>
                        {disk.isHealthy ? 'Saudável' : 'Com Problemas'}
                      </Badge>
                    </Flex>

                    <Text fontSize="sm" color="gray.600" mb={2} fontFamily="mono">
                      {disk.path}
                    </Text>

                    {!disk.isHealthy ? (
                      <Text fontSize="sm" color="red.500">
                        ⚠️ Disco inacessível ou sem permissão de escrita
                        {disk.error && `: ${disk.error}`}
                      </Text>
                    ) : disk.stats ? (
                      <>
                        {/* Barra de progresso */}
                        <Box position="relative" height="24px" bg="gray.200" borderRadius="md" mb={2}>
                          <Box
                            position="absolute"
                            top="0"
                            left="0"
                            height="100%"
                            width={`${usagePercent}%`}
                            bg={`${colorScheme}.400`}
                            borderRadius="md"
                            transition="width 0.3s"
                          />
                          <Flex
                            position="absolute"
                            top="0"
                            left="0"
                            right="0"
                            height="100%"
                            align="center"
                            justify="center"
                          >
                            <Text fontSize="xs" fontWeight="bold" color="white" textShadow="0 1px 2px rgba(0,0,0,0.5)">
                              {usagePercent}%
                            </Text>
                          </Flex>
                        </Box>

                        {/* Detalhes de espaço */}
                        <Grid templateColumns="repeat(3, 1fr)" gap={2}>
                          <Box>
                            <Text fontSize="xs" color="gray.500">Usado</Text>
                            <Text fontSize="sm" fontWeight="medium">
                              {formatBytes(disk.stats.used)}
                            </Text>
                          </Box>
                          <Box>
                            <Text fontSize="xs" color="gray.500">Disponível</Text>
                            <Text fontSize="sm" fontWeight="medium">
                              {formatBytes(disk.stats.available)}
                            </Text>
                          </Box>
                          <Box>
                            <Text fontSize="xs" color="gray.500">Total</Text>
                            <Text fontSize="sm" fontWeight="medium">
                              {formatBytes(disk.stats.total)}
                            </Text>
                          </Box>
                        </Grid>
                      </>
                    ) : (
                      <Text fontSize="sm" color="green.600">
                        ✅ Disco acessível e funcionando
                        <br />
                        <Text as="span" fontSize="xs" color="gray.500">
                          (Estatísticas de espaço não disponíveis - instale o módulo check-disk-space)
                        </Text>
                      </Text>
                    )}
                  </Box>
                );
              })}
            </VStack>
          </VStack>
        ) : (
          <Box textAlign="center" py={4}>
            <Text color="gray.500">
              Informações de armazenamento não disponíveis.
              <br />
              Certifique-se de que o STORAGE_PATHS está configurado no .env
            </Text>
          </Box>
        )}
      </Box>

      {loading ? (
        <Flex justify="center" align="center" height="300px">
          <Spinner size="xl" />
        </Flex>
      ) : machines.length === 0 ? (
        <Box textAlign="center" p={8} bg="white" borderRadius="md" boxShadow="md">
          <Text fontSize="xl" mb={4}>Nenhuma máquina encontrada</Text>
          <Text color="gray.500">As máquinas serão registradas automaticamente quando executarem o serviço de reconhecimento.</Text>
        </Box>
      ) : (
        <Grid templateColumns="repeat(auto-fill, minmax(350px, 1fr))" gap={6}>
          {machines.map((machine) => (
            <GridItem key={machine.id} w="100%" bg="white" boxShadow="md" borderRadius="md" overflow="hidden">
              <Box 
                bg={machine.status ? "green.500" : "red.500"} 
                color="white" 
                p={4} 
                fontWeight="bold"
              >
                <Flex justify="space-between" align="center">
                  <Flex align="center">
                    <StatusIcon />
                    <Text fontSize="lg">{machine.name}</Text>
                  </Flex>
                  <Badge 
                    colorScheme={machine.status ? "green" : "red"} 
                    variant="solid" 
                    borderRadius="full" 
                    px={3} 
                    py={1}
                  >
                    {machine.status ? "Online" : "Offline"}
                  </Badge>
                </Flex>
              </Box>
              
              <Box p={4}>
                <VStack align="start" spacing={3} divider={<Divider />}>
                  <HStack>
                    <IPIcon />
                    <Text fontWeight="medium">Endereço IP:</Text>
                    <Text>{machine.ip_address || "Não disponível"}</Text>
                  </HStack>
                  
                  <HStack>
                    <MacIcon />
                    <Text fontWeight="medium">Endereço MAC:</Text>
                    <Text>{machine.mac_address || "Não disponível"}</Text>
                  </HStack>
                  
                  <HStack>
                    <TimeIcon />
                    <Text fontWeight="medium">Última atividade:</Text>
                    <Text>{formatLastRequestTime(machine.last_request_time)}</Text>
                  </HStack>
                  
                  {/* Seção de câmeras */}
                  <Box width="100%">
                    <Accordion allowToggle>
                      <AccordionItem border="none">
                        <AccordionButton 
                          px={0}
                          onClick={() => !machinesCameras[machine.id] && fetchMachineCameras(machine.id)}
                        >
                          <Box flex="1" textAlign="left" display="flex" alignItems="center">
                            <CameraIcon />
                            <Text fontWeight="medium">Câmeras ativas</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={4} pl={0} pr={0}>
                          {loadingCameras[machine.id] ? (
                            <Flex justify="center" py={2}>
                              <Spinner size="sm" />
                            </Flex>
                          ) : machinesCameras[machine.id]?.length ? (
                            <VStack align="stretch" spacing={3}>
                              {machinesCameras[machine.id].map((camera, idx) => (
                                <Box key={idx} p={3} borderWidth="1px" borderRadius="md" borderColor="gray.200" bg="gray.50">
                                  <HStack justify="space-between" align="start" mb={2}>
                                    <Box>
                                      <Text fontWeight="semibold">{camera.name || `Câmera ${camera.id}`}</Text>
                                      <Text fontSize="xs" color="gray.500">{camera.location || 'Sem localização'}</Text>
                                    </Box>
                                    <Badge colorScheme="blue" variant="subtle">ID {camera.id}</Badge>
                                  </HStack>
                                  <Text fontSize="xs" color="gray.600" mb={2}>Algoritmos ativos:</Text>
                                  <HStack spacing={2} flexWrap="wrap">
                                    {camera.algorithms.map((algo, i) => (
                                      <Badge key={i} colorScheme="purple" variant="subtle">{algo}</Badge>
                                    ))}
                                  </HStack>
                                </Box>
                              ))}
                            </VStack>
                          ) : (
                            <Text pl={6} color="gray.500">
                              {machine.status ? 
                                "Nenhuma câmera ativa nesta máquina" : 
                                "Máquina offline - informações não disponíveis"}
                            </Text>
                          )}
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                  </Box>
                  
                  <Text fontSize="sm" color="gray.500">
                    Registrado em: {new Date(machine.createdAt).toLocaleDateString('pt-BR')}
                  </Text>
                  
                  <Flex justify="space-between" width="100%" mt={2}>
                    <Button 
                      colorScheme="blue" 
                      size="sm" 
                      onClick={() => handleEditMachine(machine)}
                    >
                      Editar
                    </Button>
                    <Button 
                      colorScheme="red" 
                      size="sm" 
                      variant="outline"
                      onClick={() => openDeleteConfirmation(machine)}
                    >
                      Remover
                    </Button>
                  </Flex>
                </VStack>
              </Box>
            </GridItem>
          ))}
        </Grid>
      )}

      {/* Modal de Edição */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Editar Máquina</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {editMachine && (
              <FormControl>
                <FormLabel>Nome da Máquina</FormLabel>
                <Input
                  name="name"
                  value={editMachine.name}
                  onChange={handleInputChange}
                  mb={4}
                />
                
                <FormLabel>Endereço IP</FormLabel>
                <Input
                  name="ip_address"
                  value={editMachine.ip_address}
                  onChange={handleInputChange}
                  mb={4}
                />
                
                <FormLabel>Endereço MAC</FormLabel>
                <Input
                  name="mac_address"
                  value={editMachine.mac_address || ""}
                  onChange={handleInputChange}
                  mb={4}
                  isReadOnly
                  bg="gray.100"
                />
                
                <FormLabel display="flex" alignItems="center">
                  Status: 
                  <Badge 
                    ml={2} 
                    colorScheme={editMachine.status ? "green" : "red"}
                  >
                    {editMachine.status ? "Online" : "Offline"}
                  </Badge>
                </FormLabel>
                
                {editMachine.last_request_time && (
                  <FormLabel display="flex" alignItems="center" mt={2}>
                    <TimeIcon />
                    Última atividade: {formatLastRequestTime(editMachine.last_request_time)}
                  </FormLabel>
                )}
              </FormControl>
            )}
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Cancelar
            </Button>
            <Button colorScheme="blue" onClick={handleUpdateMachine}>
              Salvar Alterações
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      
      {/* Alerta de confirmação para deletar */}
      <AlertDialog
        isOpen={isDeleteAlertOpen}
        leastDestructiveRef={cancelRef}
        onClose={() => {
          setDeleteStep(1);
          setDeleteLinkedCameras([]);
          setIsDeleteAlertOpen(false);
        }}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {deleteStep === 1 ? 'Excluir Máquina' : 'Confirmar Exclusão com Desvinculação'}
            </AlertDialogHeader>

            <AlertDialogBody>
              {checkingLinkedCameras ? (
                <Flex align="center" gap={2}>
                  <Spinner size="sm" />
                  <Text>Verificando câmeras vinculadas...</Text>
                </Flex>
              ) : deleteStep === 1 ? (
                <>
                  <Text>Tem certeza que deseja excluir a máquina "{machineToDelete?.name}"?</Text>
                  {deleteLinkedCameras.length > 0 && (
                    <Text mt={2} color="orange.500" fontWeight="semibold">
                      Esta máquina possui {deleteLinkedCameras.length} câmera(s) vinculada(s). Você verá uma segunda confirmação.
                    </Text>
                  )}
                  <Text mt={2} fontWeight="bold" color="red.500">
                    Esta ação não pode ser desfeita.
                  </Text>
                </>
              ) : (
                <>
                  <Text>
                    Ao excluir, as câmeras abaixo serão desvinculadas desta máquina e ficarão sem vínculo:
                  </Text>
                  <VStack mt={3} spacing={2} align="stretch" maxH="180px" overflowY="auto">
                    {deleteLinkedCameras.map((camera) => (
                      <Box key={camera.id} p={2} borderWidth="1px" borderRadius="md" borderColor="orange.200" bg="orange.50">
                        <Text fontSize="sm" fontWeight="semibold">{camera.name || `Câmera ${camera.id}`}</Text>
                        <Text fontSize="xs" color="gray.600">{camera.location || camera.rtsp_address || 'Sem detalhes'}</Text>
                      </Box>
                    ))}
                  </VStack>
                  <Text mt={3} fontWeight="bold" color="red.500">
                    Confirma a exclusão e desvinculação?
                  </Text>
                </>
              )}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                onClick={() => {
                  setDeleteStep(1);
                  setDeleteLinkedCameras([]);
                  setIsDeleteAlertOpen(false);
                }}
              >
                Cancelar
              </Button>
              <Button colorScheme="red" onClick={handleDeleteMachine} ml={3} isLoading={checkingLinkedCameras}>
                {deleteStep === 1 && deleteLinkedCameras.length > 0 ? 'Continuar' : 'Excluir'}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default Machines;